import React, { Component } from 'react';
import moment from 'moment';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, change, getFormValues } from 'redux-form';

import TextInput from '../TextInput';
import Select from '../Select';
import DateInput from '../DateInput';
import SignatureInput from '../SignatureInput';
import { getCountries } from '../../enums/countries';
import { getSexOptions, getIdcardTypeOptions, isVisaRequiredForCountry, isAtLeast15 } from '../../enums/GuestDetails';
import withLocalize from '../../withLocalize';
import T from '../Translate';

class Guest extends Component {

	isRequired = (field) => {
		return this.props.requiredFields.includes(field);
	};

	componentDidMount() {
		const { index, guest, defaultCitizenshipId, defaultGuestCountryId, dispatch } = this.props;

		if (!guest.citizenship_id && defaultCitizenshipId) {
			dispatch(change('bookingForm', `guestDetails[${index}][citizenship_id]`, defaultCitizenshipId));
		}
		if (!guest.country_id && defaultGuestCountryId) {
			dispatch(change('bookingForm', `guestDetails[${index}][country_id]`, defaultGuestCountryId));
		}
	}

	render() {
		const { index, guest, countries, translate: t } = this.props;

		const namePrefix = `guestDetails[${index}]`;

		return (
			<fieldset className="fieldset">
				<legend><T id="GuestDetails.guest" data={{ count: index + 1 }} /></legend>

				<div className="fieldset__fields-row">
					<Field
						component={TextInput}
						name={`${namePrefix}[firstname]`}
						label={t('GuestDetails.firstname')}
						required={this.isRequired('firstname')}
					/>
					<Field
						component={TextInput}
						name={`${namePrefix}[surname]`}
						label={t('GuestDetails.surname')}
						required={this.isRequired('surname')}
					/>
				</div>

				<div className="fieldset__fields-row">
					<Field
						component={Select}
						name={`${namePrefix}[sex]`}
						label={t('GuestDetails.sex')}
						options={getSexOptions(t)}
					/>
					<div className="large-input-container">
						<Field
							component={DateInput}
							name={`${namePrefix}[birth_date]`}
							label={t('GuestDetails.birthDate')}
							required={this.isRequired('birth_date')}
							maxDate={moment()}
							yearRange={[1900, moment().year()]}
							defaultAnchorDate={moment().subtract(30, 'years')}
						/>
					</div>
				</div>

				<div className="fieldset__fields-row">
					<Field
						component={Select}
						name={`${namePrefix}[citizenship_id]`}
						label={t('GuestDetails.citizenship')}
						options={getCountries(t)}
						searchable
					/>
				</div>

				<div className="fieldset__fields-row">
					<Field
						component={Select}
						name={`${namePrefix}[idcard_type_id]`}
						label={t('GuestDetails.idcardType')}
						options={getIdcardTypeOptions(t)}
					/>
					<Field
						component={TextInput}
						name={`${namePrefix}[idcard_number]`}
						label={t('GuestDetails.idcardNumber')}
						required={this.isRequired('idcard_type_id') && isAtLeast15(guest.birth_date)}
					/>
					{isVisaRequiredForCountry(countries, guest.citizenship_id) &&
					<Field
						component={TextInput}
						name={`${namePrefix}[visa]`}
						label={t('GuestDetails.visa')}
						required={this.isRequired('idcard_type_id')}
					/>
					}
				</div>

				<div className="fieldset__fields-row">
					<Field
						component={TextInput}
						name={`${namePrefix}[street]`}
						label={t('GuestDetails.street')}
						required={this.isRequired('street')}
					/>
					<Field
						component={TextInput}
						name={`${namePrefix}[city]`}
						label={t('GuestDetails.city')}
						required={this.isRequired('city')}
					/>
				</div>

				<div className="fieldset__fields-row">
					<Field
						component={TextInput}
						name={`${namePrefix}[zip]`}
						label={t('GuestDetails.zip')}
						required={this.isRequired('zip')}
					/>
					<Field
						component={Select}
						name={`${namePrefix}[country_id]`}
						label={t('GuestDetails.country')}
						options={getCountries(t)}
						searchable
					/>
				</div>

				<div className="fieldset__fields-row">
					<Field
						component={SignatureInput}
						name={`${namePrefix}[signature]`}
						label={t('GuestDetails.signature')}
						required={index !== 0 && this.isRequired('signature')}
					/>
				</div>
			</fieldset>
		);
	}
}

export default compose(
	connect((state, props) => ({
		guest: ((getFormValues('bookingForm')(state) || {}).guestDetails || [])[props.index] || {},
		requiredFields: state.app.requiredFields || [],
		countries: state.app.countries || [],
		defaultCitizenshipId: state.app.defaultCitizenshipId,
		defaultGuestCountryId: state.app.defaultGuestCountryId,
	})),
	withLocalize,
)(Guest);



// WEBPACK FOOTER //
// ./src/components/GuestDetails/Guest.jsx